import { useNavigate } from "react-router-dom";
import { useAuthContext } from "providers/Auth";
import { unitFraudAlertsPath } from "shared/app/fraudAlertUtils";
import { PROPERTY_SHIELD_MARK } from "shared/app/PoweredByPropertyShield";

export const UnitFraudAlertPill = ({
  count,
  propertyId,
  unitId
}: {
  count?: number;
  propertyId: number;
  unitId: number;
}) => {
  const { type } = useAuthContext();
  const navigate = useNavigate();

  if (!type.isListingFraudAlerts || !count || count <= 0) return null;

  return (
    <button
      type="button"
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        navigate(unitFraudAlertsPath(propertyId, unitId));
      }}
      aria-label={`${count} active fraud ${count === 1 ? "alert" : "alerts"}`}
      title="Possible fraudulent listing found — Powered by Property Shield"
      className="flex h-6 items-center gap-1 rounded-full bg-[#284389] px-2 text-sm font-bold text-white shadow-xs"
    >
      <img
        src={PROPERTY_SHIELD_MARK}
        alt=""
        className="size-3.5 shrink-0 object-contain"
      />
      {count}
    </button>
  );
};
